import { requestFreshBootstrapToken } from "$lib/stores/bootstrapTokenStore";
import { exchangeBootstrapToken } from "$lib/authExchange";
import { logger } from "$lib/logger";

let inflightExchange: Promise<void> | null = null;

async function refreshSession(): Promise<void> {
  if (inflightExchange) {
    return inflightExchange;
  }

  inflightExchange = (async () => {
    const freshToken = await requestFreshBootstrapToken();
    await exchangeBootstrapToken(freshToken);
  })();

  try {
    await inflightExchange;
  } finally {
    inflightExchange = null;
  }
}

export async function authenticatedFetch(
  url: string,
  options?: RequestInit,
): Promise<Response> {
  const response = await fetch(url, { ...options, credentials: "include" });

  if (response.status !== 401) {
    return response;
  }

  logger.info("BFF returned 401 — requesting fresh bootstrap token");

  try {
    await refreshSession();
  } catch (err) {
    logger.info(`Bootstrap token refresh failed: ${String(err)}`);
    throw err;
  }

  return fetch(url, { ...options, credentials: "include" });
}
